module.exports = __webpack_public_path__ + "static/netflix-estacao-4-9fd910d111a007ac5b442bf04376b2b9.jpg";